import cx from 'clsx';

type Props = {
  className?: string;
  style?: React.CSSProperties;
};

export const SectionDivider = ({ className, style }: Props) => {
  return (
    <div
      className={cx('w-full bg-gray-100 h-12', className)}
      style={{ ...style }}
    />
  );
};
